import React from "react";
import styles from "./Switcher.module.scss";
import { SwitcherPropsType } from "./types";

export const Switcher: React.FC<SwitcherPropsType> = ({
  options,
  activeValue,
  onChange,
  className,
}) => {
  return (
    <div className={`${styles.switcher} ${className || ""}`}>
      {options.map((option) => (
        <button
          key={option.value}
          className={`${styles.switcher__button} ${
            activeValue === option.value ? styles.switcher__button_active : ""
          }`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

